import {Component, OnInit, Input, NgModule, NO_ERRORS_SCHEMA, AfterViewInit} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {Classifications} from '../classifications';
import {UsersShowComponent} from '../../users/users-show/users-show.component';
import {BranchesShowComponent} from '../../branches/branches-show/branches-show.component';
import {ClassificationsService} from '../classifications.service';
import {ActivatedRoute, Router} from '@angular/router';
import {SharedService} from '../../../../services/SharedService.service';
import {ConfirmationService, Message} from 'primeng/api';
import {MessageService} from 'primeng/components/common/messageservice';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AppLogComponent} from '../../../../components/app-log/app-log.component'
import {appConfig} from "../../../../app.config";
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import {BrowserModule} from "@angular/platform-browser";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CommonModule} from "@angular/common";
import {ConfirmDialogModule, DropdownModule, MessagesModule} from "primeng/primeng";
import {Http} from "@angular/http";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {UserPictureComponent} from "../../../../components/user-picture";
import {RecordDataComponent} from "../../../../components/record-data";
import {AppArcComponent} from "../../../../components/app-arc";
import {MyInputsModule} from "../../../../my-inputs/my-inputs.module";
import {BranchService} from "../../branches/branch.service";
import {UserService} from '../../../../services';
import {TreeNode} from 'primeng/api';
import {TreeModule} from "primeng/tree";


@NgModule({
    imports: [CommonModule, FormsModule, TreeModule, DropdownModule, MessagesModule,MyInputsModule,
        ReactiveFormsModule, ConfirmDialogModule, TranslateModule.forChild()
    ],
    declarations: [
        ClassificationsShowComponent
    ],
    entryComponents: [
        ClassificationsShowComponent
    ],
    exports: [],
    providers: [SharedService, ClassificationsService, MessageService, ConfirmationService],
    schemas: [NO_ERRORS_SCHEMA]
})

@Component({
    selector: 'app-classifications-show',
    templateUrl: './classifications-show.component.html',
    styleUrls: ['./classifications-show.component.scss'],
    providers: [ClassificationsService, ConfirmationService, MessageService]
})

export class ClassificationsShowComponent implements OnInit, AfterViewInit {
    id: string;
    classifications =  new Classifications();
    @Input() refShow;
    allclassifications: any[] = [];
    allusers: any[] = [];
    hiddenFields: any[] = [];

    applog: AppLogComponent;
    parent_name: any;
    @Input() scrId;
    modalRef: NgbModalRef;
    parent:any;
    @Input() delId;
    @Input() oldData;
    @Input() newData;
    @Input() newDatap;
    @Input() modelName;
    tree: TreeNode[];
    statusVal = [{'val': 1, 'title': 'Yes'}, {'val': 2, 'title': 'No'}];

    form: FormGroup;
    private sub: any;
    msgs: Message[] = [];
    public imgUrl = appConfig.publicUrl;
    private _editButton: any;
    private _deleteButton: any;
    private _newButton: any;
    private _printButton: any;
    private _searchButton: any;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private sharedservice: SharedService,
                private classificationsService: ClassificationsService,
                private branchService: BranchService,
                private userService: UserService,
                private modalService: NgbModal,
                public activeModal: NgbActiveModal,
                public translate: TranslateService,
                private confirmationService: ConfirmationService,
                private messageService: MessageService){
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        this.msgs =[];

        if(userdata && userdata.lang){
            this.translate.use(userdata.lang);
        }
        this.sharedservice.setTitle(this.route.snapshot.data.title);
        this.sharedservice.setButtons([
            {label: 'Delete', icon: 'fa-trash', btnClass: 'btn-danger', btnId: 'deleteButton'},
            {label: 'Edit', icon: 'fa-edit', btnClass: 'btn-warning', btnId: 'editButton'},
            // {label: 'Print', icon: 'fa-print', btnClass: 'btn-skype', btnId: 'printButton'},
            {label: 'Add', icon: 'fa-plus', btnClass: 'btn-info', btnId: 'newButton'},
            {label: 'Query', icon: 'fa-search', btnClass: 'btn-primary', btnId: 'searchButton'},
        ]);
        this.sharedservice.setModelName('classifications');
        this.sharedservice.setItemShow(ClassificationsShowComponent);
    }

    showParent(){
        if(this.parent){
            const options: NgbModalOptions = {
                beforeDismiss: () => {
                    console.log("before dismiss");
                    return true;
                }
            };
            this.modalRef = this.modalService.open(ClassificationsShowComponent, options);
            this.modalRef.componentInstance.scrId = this.parent.id;

            this.modalRef.result.then(() => {
                this.activeModal.dismiss('done');
            }, () => {
                console.log('Backdrop click')
            });
        }
    }
    recordData(){
        const options: NgbModalOptions = {
            beforeDismiss: () => {
                return true;
            }
        };
        const modalRef = this.modalService.open(RecordDataComponent, options);
        modalRef.componentInstance.refRec = this.classifications;
        modalRef.componentInstance.rowId = '';
    }

    ngAfterViewInit() {
        this.msgs =[];
        if(!this.scrId && !this.oldData && !this.scrId) {
            this._editButton = document.getElementById('editButton');
            this._deleteButton = document.getElementById('deleteButton');
            this._newButton = document.getElementById('newButton');
            this._printButton = document.getElementById('printButton');
            this._searchButton = document.getElementById('searchButton');

            if(this._editButton){
                this._editButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/classifications/edit', this.id]);
                });
            }
            
            if(this._deleteButton){
                this._deleteButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.deleteClassification(this.classifications);
                });
            }

            if(this._newButton){
                this._newButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/classifications']);
                });
            }
            if(this._searchButton){
                this._searchButton.onclick = ((e: any) => {
                    e.preventDefault();
                    this.router.navigate(['/classifications/search']);
                });
            }
        }
    }

    fieldsControl(screen: string = '') {
        if (screen === '') {
            return;
        }
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if (!userdata.fields) {
            this.hiddenFields = [];
        } else {
            this.hiddenFields = (userdata.fields.screens[screen]) ? userdata.fields.screens[screen] : [];
        }
    }

    nodeSelect(_id: string) {
        this.msgs = [];
        this.id = _id;
        this.classificationsService.getById(_id).subscribe(
            classifications => {
                this.classifications = classifications;
                this.form.patchValue({
                    id: classifications.id,
                    name: classifications.name,
                    parent_id: classifications.parent_id,
                    is_default: classifications.is_default,
                  });
                }, error => {
                    console.log(error);
                }
        );
    }

    
    addnew(_id: string) {
        this.router.navigate(['/classifications', _id]);
    }

    ngOnInit(){
        this.classificationsService.getTree('0').then(tree => this.tree = tree);
        this.msgs =[];

        this.classificationsService.getall().subscribe(
            data => {
                this.allclassifications = data.classificationslist;
            });

        this.userService.getAllUsers().subscribe(
            data => {
              this.allusers = data.userslist;
            });
        this.sub = this.route.params.subscribe(params => {
            this.id = params['id'];
        });

        this.form = new FormGroup({
            id: new FormControl({value: '', disabled: true}),
            name: new FormControl({value: '', disabled: true}),
            parent_id: new FormControl({value: '', disabled: true}),
            is_default: new FormControl({value: '', disabled: true}),
        });

        this.fieldsControl('setting.classifications');

        if(this.id){
            this.msgs =[];
            this.activeModal.dismiss('');
            this.oldData = false;
            this.newData = false;
            this.delId = false;
            this.newDatap = true;
            localStorage.removeItem('filter');
            const msg = JSON.parse(localStorage.getItem('showMessages'));
            if(msg){
                localStorage.removeItem('showMessages');
                this.msgs = msg;
            }
            this.classificationsService.getById(this.id).subscribe(
                classifications => {
                    this.id = classifications.id;
                    this.parent = classifications.parent;
                    this.classifications = classifications;
                    this.form.patchValue({
                        id: classifications.id,
                        name: classifications.name,
                        parent_id: classifications.parent_id,
                        is_default: classifications.is_default,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if(this.scrId){
            this.oldData = false;
            this.newData = false;
            this.delId = false;

            this.classificationsService.getById(this.scrId).subscribe(
                classifications => {
                    this.id = classifications.id;
                    this.parent = classifications.parent;
                    this.classifications = classifications;
                    this.form.patchValue({
                        id: classifications.id,
                        name: classifications.name,
                        parent_id: classifications.parent_id,
                        is_default: classifications.is_default,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if(this.delId){
            this.oldData = false;
            this.newData = false;
            this.newDatap = !this.newDatap ;
            this.classificationsService.getTrashedById(this.delId).subscribe(
                classifications => {
                    this.classifications = classifications;
                    this.form.patchValue({
                        id: classifications.id,
                        name: classifications.name,
                        parent_id: classifications.parent_id,
                        is_default: classifications.parent_id,
                    });
                }, error => {
                    console.log(error);
                }
            );
        }

        if(this.oldData && this.newData){
            this.classifications = this.newData;
            this.form.patchValue({
                id: this.newData.id,
                name: this.newData.name,
                parent_id: this.newData.parent_id,
                is_default: this.newData.is_default,
            });
        }
    }

    permissionAllow(button: string): boolean {
        let userRoles: any[] = [];
        const userdata = JSON.parse(localStorage.getItem('currentUser'));
        if(userdata){
            userRoles = userdata.roles.description;
        }
        let role: string = '';
        switch (button){
            case 'newButton': {
                role = 'create';
                break;
            }
            /*  case 'recordDataButton': {
                  role = 'recordData';
                  break;
              }*/
            case 'saveButton': {
                role = 'update';
                break;
            }
            case 'deleteButton': {
                role = 'delete';
                break;
            }
            case 'searchButton': {
                role = 'search';
                break;
            }
            case 'excelButton': {
                role = 'excel';
                break;
            }
            case 'printButton': {
                role = 'print';
                break;
            }
            case 'historyButton': {
                role = 'history';
                break;
            }
            case 'restoreButton': {
                role = 'restore';
                break;
            }
            case 'attachmentsButton': {
                role = 'attachments';
                break;
            }
            case 'rowinfo': {
                role = 'rowinfo';
                break;
            }

            default: {
                role = '';
                break;
            }
        }
        if(userRoles.indexOf('setting.classifications.' + role) >= 0){
            return true;
        }
        return false;
    }

    deleteClassification(classifications: Classifications){
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Delete'),
            message: this.translate.instant('Are you sure of delete ?'),
            icon: 'fa fa-trash',
            accept: () => {
                if(classifications){
                    this.classificationsService.delete(classifications.id).subscribe(
                        res => {
                            if (res.result == false) {
                                this.msgs.push({
                                    severity: 'error',
                                    summary: '',
                                    detail: this.translate.instant(res.message)
                                });
                            } else {
                                this.msgs.push({
                                    severity: 'success',
                                    summary: '',
                                    detail: this.translate.instant('Delete completed')

                                });
                                setTimeout(() => {
                                    this.router.navigate(['/classifications']);
                                }, 1000);
                            }
                            localStorage.setItem('showMessages', JSON.stringify(this.msgs));
                        }
                    );
                }
            }
        });
    }

    recoverEdit(classifications: Classifications){
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Edit'),
            message: this.translate.instant('Are you sure of undo ?. All data will be recover as seen in screen and any other editing will be dismiss'),
            icon: 'fa fa-undo',
            accept: () => {
                if(classifications){
                    this.classificationsService.update(classifications).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Data returned')
                            });
                            this.activeModal.close('done');
                            this.router.navigate(['/classifications/show', classifications.id]);
                        }
                    );
                }
            }
        });
    }

    undotrashed(){
        this.confirmationService.confirm({
            header: this.translate.instant('Confirm Undo Delete'),
            message: this.translate.instant('Are you sure about recover deleted item?'),
            icon: 'fa fa-undo',
            accept: () => {
                if(this.delId){
                    this.classificationsService.restoreTrashedById(this.delId).subscribe(
                        res => {
                            this.msgs = [];
                            this.msgs.push({
                                severity: 'success',
                                summary: '',
                                detail: this.translate.instant('Deleted classifications recovered')
                            });
                            this.activeModal.dismiss('close click');
                            this.router.navigate(['/classifications/list']);
                        }
                    );
                }
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/views/setting/classifications/classifications-show/classifications-show.component.ts